export type ShippingGeneralConfig = {
  enabled: boolean;
  type: 'flat_rate' | 'free' | 'zone_based' | 'weight_based' | 'conditional';
  flatRate?: number;
  freeShippingThreshold?: number;
  defaultCost?: number;
};

let shippingConfigCache: ShippingGeneralConfig | null = null;

export function setShippingConfig(cfg: ShippingGeneralConfig) {
  shippingConfigCache = cfg;
}

export function getShippingConfig(): ShippingGeneralConfig | null {
  return shippingConfigCache;
}

